import React from 'react'

export const Footer = () => {
  return (
    <div className='footer'>
        BYD ADMIN &#169;
    </div>
  )
}
